export const EXSBITEMSCATEGORY_DELETE_RESET = 'EXSBITEMSCATEGORY_DELETE_RESET'
export const EXSBITEMSCATEGORY_DELETE_SET_ERROR = 'EXSBITEMSCATEGORY_DELETE_SET_ERROR'
export const EXSBITEMSCATEGORY_DELETE_SET_DELETED = 'EXSBITEMSCATEGORY_DELETE_SET_DELETED'
export const EXSBITEMSCATEGORY_DELETE_TOGGLE_LOADING = 'EXSBITEMSCATEGORY_DELETE_TOGGLE_LOADING'
